import { queryOptions } from '@tanstack/react-query';

import { signupApi } from './services/signupApi';

/** Onboarding state for the signed-in user. */
export const onboardingQuery = (userId: number | undefined) =>
  queryOptions({
    queryKey: ['onboarding', userId],
    queryFn: () => signupApi.onboarding(),
    retry: false,
    staleTime: Infinity,
  });
